export const resultText = {
  topafslag: {
    short:
      'Je kunt waarschijnlijk besparen doordat je in een lagere risicoklasse valt.',
    long:
      `Je kunt waarschijnlijk besparen op je maandlasten als je van je huidige
      geldverstrekker rentekorting krijgt (topafslag). Dat is mogelijk als je
      woning in waarde is gestegen en/of je al voldoende op je hypotheek hebt
      afgelost. Je lening komt dan in een lagere risicoklasse, met een lager
      rentepercentage. Het lijkt erop dat dit voor jouw hypotheek nog niet
      (automatisch) is aangepast. In dat geval betaal je te veel rente.`,
  footer:
      'Op basis van de verstrekte gegevens schatten we in wat je door een topafslag bespaart. ' +
      'De getoonde besparing is alleen gebaseerd op basis van de betaalde rente. ' +
      'Ook zie je in hoeveel maanden je de kosten terugverdient die (gemiddeld) voor deze een topafslag moet maken. ' +
      "Je nieuwe maandlasten geven we 'bruto' weer, net als de besparing. " +
      'Dus vóór aftrek van de rente bij je belastingaangifte.' +
      'Let op: Het kan zijn dat je bank bij afsluiten van je hypotheek andere risicoklasses hanteerde ' +
      'waardoor er afwijkingen kunnen plaatsvinden op de mogelijke besparing.',
  },
  'intern oversluiten': {
    short: `Je huidige geldverstrekker heeft een product dat mogelijk voordeliger voor je is!`,
    long:
      `Je kunt bij je huidige geldverstrekker besparen op je maandlasten als je
      je lopende hypotheek vervroegd aflost. Dat doe je met een nieuwe
      hypotheek tegen een lagere rente. Bij vroegtijdig aflossen berekent je hypotheek verstrekker kosten voor 
      vervroegd aflossen en je maakt daarna kosten voor een taxatie, de notaris en advies. Veel van
      deze kosten zijn aftrekbaar voor de belasting. Voordeel van het
      afkopen van je huidige rentecontract is dat je niet opnieuw notariskosten
      en een bankgarantie moet betalen. Vraag je adviseur om een maatwerk
      berekening.`,
  footer:
      'Op basis van de verstrekte gegevens schatten we in wat je met Intern Oversluiten per maand bespaart. ' +
      'De getoonde besparing is alleen gebaseerd op basis van de betaalde rente. ' +
      'Ook zie je in hoeveel maanden je de kosten terugverdient die (gemiddeld) voor deze situatie gelden. ' +
      "Je nieuwe maandlasten geven we 'bruto' weer, net als de besparing. " +
      'Dus vóór aftrek van de rente bij je inkomstenbelasting. '+
      'Let op: Bij een lagere rente is het aftrekbare bedrag natuurlijk ook lager',
  },
  oversluiten: {
    short: `Je kunt waarschijnlijk besparen als je nu je hypotheek oversluit! `,
    long:
      `Je kunt besparen op je maandlasten als je je lopende hypotheek vervroegd
      aflost en ergens anders een nieuwe afsluit. Bij vroegtijdig aflossen berekent je hypotheek verstrekker kosten voor 
      vervroegd aflossen en je maakt daarna kosten voor een taxatie, de notaris en advies. Veel van
      deze kosten zijn aftrekbaar voor de belasting. Vraag je adviseur om een
      persoonlijke berekening.`,
    footer:
      'Op basis van de verstrekte gegevens schatten we in wat je bespaart door je hypotheek over te sluiten. ' +
      'De getoonde besparing is alleen gebaseerd op basis van de betaalde rente. ' +
      'Ook zie je in hoeveel maanden je de kosten terugverdient die ' +
      '(gemiddeld) voor oversluiten gemaakt moeten worden. ' +
      "Je nieuwe maandlasten geven we 'bruto' weer, net als de besparing. " +
      'Dus vóór aftrek van de rente bij je belastingaangifte. ' +
      'Let op: Bij een lagere rente is het aftrekbare bedrag natuurlijk ook lager',
  },
  verhuizen: {
    short: 'Je kunt waarschijnlijk besparen op het moment dat je gaat verhuizen! ',
    long:
      `Als je verhuist, kun je je hypotheek zonder kosten vervroegd aflossen en een nieuwe
      hypotheek aangaan. Voor je nieuwe hypotheek/woning betaal je opnieuw voor
      verschillende zaken, zoals overdrachtsbelasting en taxatie-, notaris- en
      advieskosten. Met deze kosten wordt rekening gehouden met terugverdientijd.
      Veel van deze kosten zijn aftrekbaar voor de belasting.
      Verhuizen en inrichten kost natuurlijk ook geld. Vraag je adviseur om een
      persoonlijke berekening.`,
    footer:
      'Op basis van de verstrekte gegevens schatten we in wat je door te verhuizen per maand bespaart. '+
      'De getoonde besparing is alleen gebaseerd op basis van de betaalde rente. ' +
      'Ook zie je in hoeveel maanden je de kosten terugverdient die (gemiddeld) voor deze situatie gelden. ' +
      'Als uitgangspunt van de berekening gaan we uit van een nieuwe hypotheek ' +
      'voor het zelfde bedrag als je huidige hypotheek. ' +
      "Je nieuwe maandlasten geven we 'bruto' weer, net als de besparing. " +
      'Dus vóór aftrek van de rente bij je belastingaangifte. ' +
      'Let op: Bij een lagere rente is het aftrekbare bedrag natuurlijk ook lager',
  },
};
